"use client";

import Input from "./Input";
import Field from "./Field";

function Username({
  autoFocus,
  errorMessage,
  fieldName,
  label,
  requiredPlaceholder,
}: {
  autoFocus?: boolean;
  errorMessage: string;
  fieldName: string;
  label: string;
  requiredPlaceholder?: string;
}): JSX.Element | null {
  return (
    <Field
      errorMessage={errorMessage}
      fieldControl={(value, onChange, inError, onBlur) => (
        <Input
          autoComplete="username"
          autoFocus={autoFocus}
          className="w-72"
          inError={inError}
          onBlur={onBlur}
          onChange={onChange}
          required={Boolean(errorMessage)}
          requiredPlaceholder={requiredPlaceholder}
          value={value}
        />
      )}
      fieldName={fieldName}
      fieldValidations={{ required: errorMessage }}
      label={label}
    />
  );
}

export default Username;
